import React, { useEffect, useMemo } from "react";
import TableWidget from "../../../components/tables/TableWidget";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import {
  fetchGetClientsNodes,
  fetchUndeliveredBins,
  getBinStatuses,
} from "../../../redux/api/expedition.api";
import { clearWorkingRoutesNodes } from "../../../redux/reducer/expedition.reducer";
import {
  getUndeliveredBinsTableData,
  undeliveredBinsHistoryTableHeader,
} from "./tableConfigs/undeliveredBinsTableConfig";
import UndeliveredBinsActionButtons from "./components/ActionButtons/UndeliveredBinsActionButtons";

function UndeliveredBins() {
  const dispatch = useAppDispatch();

  const {
    expedition: {
      undeliveredBins: {
        data: { data: dataUndeliveredBins, total: totalUndeliveredBins },
        isLoading: isLoadingUndeliveredBins,
      },
      workingRoutesNodes: {
        data: { data: clientsNodesData },
        isLoading: isLoadingNodes,
      },
      binStatuses: { data: binStatusesData, isLoading: isLoadingBinStatus },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  useEffect(() => {
    dispatch(
      fetchGetClientsNodes({
        page: 1,
        perPage: 50,
      }),
    );

    dispatch(getBinStatuses());

    return () => {
      dispatch(clearWorkingRoutesNodes());
    };
  }, [dispatch]);

  const handleBinTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch &&
      action.tableFilter
    ) {
      dispatch(
        fetchUndeliveredBins({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          sn_bin: action.tableSearch.sn_bin,
          nodDestinatie: action.tableFilter.nodDestinatie,
          nodPreluare: action.tableFilter.nodPreluare,
          status: action.tableFilter.status,
        }),
      );
    }
  };

  const undeliveredBinHistoryTableHeaderNew = useMemo(
    () =>
      undeliveredBinsHistoryTableHeader.map((item) => {
        if (!isLoadingNodes && item.value === "nodDestinatie") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }
        if (!isLoadingNodes && item.value === "nodPreluare") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }
        if (!isLoadingBinStatus && item.value === "status") {
          const binStatusesDropdown = binStatusesData?.map(
            ({ denumire, valoare }) => ({
              label: denumire,
              value: valoare,
            }),
          );
          return {
            withFilter: [
              { label: "Toate", value: "all" },
              ...binStatusesDropdown,
            ],
            ...item,
          };
        }
        return item;
      }),

    [binStatusesData, clientsNodesData, isLoadingBinStatus, isLoadingNodes],
  );

  return (
    <TableWidget
      tableTitle="Binuri nefinalizate"
      tableHeaderData={undeliveredBinHistoryTableHeaderNew}
      tableItemsData={getUndeliveredBinsTableData(dataUndeliveredBins)}
      totalItems={totalUndeliveredBins}
      tableLoading={isLoadingUndeliveredBins}
      handleTableActions={handleBinTableActions}
      ActionButtonsComponent={(props: any) => (
        <UndeliveredBinsActionButtons {...props} />
      )}
      borderedRow
    />
  );
}

export default UndeliveredBins;
